export default {
  isRent: (state) => state.userSession?.trade === 'RENT',
  subMerchantAppList(state) {
    return state.userInfo.subMerchantAppList
  },
  // 检查指定的功能代码是否存在
  hasFunction: (state) => (code) => {
    const searchInList = (list) => {
      for (const item of list) {
        if (item.code === code) {
          return true
        }
        if (item.children && item.children.length > 0) {
          if (searchInList(item.children)) {
            return true
          }
        }
      }
      return false
    }

    const funcList = state.userSession?.funcList || []
    return searchInList(funcList)
  },
  partyId: (state) => state.userSession?.currentBu?.id,
  currencyListMapping: (state) => listToMap(state.currencyList),
  currencySymbolMapping: (state) => listToMap(state.currencyList, 'currency_symbol'),
  documentTypeMapping: (state) => listToMap(state.document_type),
  payableOrderStatusMapping: (state) => listToMap(state.payable_order_status),
  payableOrderTypeMapping: (state) => listToMap(state.payable_order_type),
  initCapitalBalanceStatusMapping: (state) => listToMap(state.init_capital_balance_status),
  initAccountBalanceStatusMapping: (state) => listToMap(state.init_account_balance_status),
  invoiceTypeMapping: (state) => listToMap(state.invoice_type),
  invoiceBizTypeMapping: (state) => listToMap(state.invoice_biz_type),
  invoiceStatusMapping: (state) => listToMap(state.invoice_status),
  payableOrderInvoiceStatusMapping: (state) => listToMap(state.payable_order_invoice_status),
  paymentRequestStatusMapping: (state) => listToMap(state.payment_request_status),
  paymentRequestTypeMapping: (state) => listToMap(state.payment_request_type),
  paymentNoteStatusMapping: (state) => listToMap(state.payment_note_status),
  paymentNoteTypeMapping: (state) => listToMap(state.payment_note_type),
  depositPaymentTypeMapping: (state) => listToMap(state.deposit_payment_type),
  depositPaymentStatusMapping: (state) => listToMap(state.deposit_payment_status),
  sourceOrderTypeMapping: (state) => listToMap(state.source_order_type),
  bizOrderStatusMapping: (state) => listToMap(state.payable_order_biz_status),
  journalVoucherTypeMapping: (state) => listToMap(state.journal_voucher_type),
  journalVoucherStatusMapping: (state) => listToMap(state.journal_voucher_status),
  receivableOrderStatusMapping: (state) => listToMap(state.receivable_order_status),
  receivableOrderTypeMapping: (state) => listToMap(state.receivable_order_type),
  receiptNoteStatusMapping: (state) => listToMap(state.receipt_note_status),
  receiptNoteTypeMapping: (state) => listToMap(state.receipt_note_type),
  goodsTypeMapping: (state) => listToMap(state.goods_type),
  expenseTypeMapping: (state) => listToMap(state.expense_type),
  writtenOffTypeMapping: (state) => listToMap(state.written_off_type),
  assetCardStatusMapping: (state) => listToMap(state.asset_card_status),
  assetOperateStatusMapping: (state) => listToMap(state.asset_operate_status),
  bankCapitalTypeMapping: (state) => listToMap(state.bank_capital_type),
  capitalTypeMapping: (state) => listToMap(state.capital_type),
  accountPurposeMapping: (state) => listToMap(state.account_purpose),
  cashFlowTypeMapping: (state) => listToMap(state.cash_flow_type),
  cashFlowAccountTypeMapping: (state) => listToMap(state.cash_flow_account_type),
  fundingDirectionMapping: (state) => listToMap(state.funding_direction),
  balanceDirectionMapping: (state) => listToMap(state.balance_direction),
  contactTypeMapping: (state) => listToMap(state.contact_type),
  settlementMethodTypeMapping: (state) => listToMap(state.settlement_method_type),
  incomeCostConfirmStatusMapping: (state) => listToMap(state.income_cost_confirm_status),
  incomeCostConfirmOrderTypeMapping: (state) => listToMap(state.income_cost_confirm_order_type),
  incomeCostConfirmOrderStatusMapping: (state) => listToMap(state.income_cost_confirm_order_status),
  incomePlanStatusMapping: (state) => listToMap(state.income_plan_status),
  incomePlanTypeMapping: (state) => listToMap(state.income_plan_type),
  incomePlanDetailStatusMapping: (state) => listToMap(state.income_plan_detail_status),
  incomePlanAllocationMethodMapping: (state) => listToMap(state.income_plan_allocation_method),
  incomePlanAllocationPushStatusMapping: (state) =>
    listToMap(state.income_plan_allocation_push_status),
  financialStatementMergeMethodMapping: (state) =>
    listToMap(state.financial_statement_merge_method),
  financialStatementControlTypeMapping: (state) =>
    listToMap(state.financial_statement_control_type),
  statementTemplateExpressTypeMapping: (state) => listToMap(state.statement_template_express_type),
}

function listToMap(list = [], label = 'name') {
  let obj = {}
  list.forEach((item) => {
    obj[item.code] = item[label]
  })
  return obj
}
